import { ReduxAction } from '../../actions';
import { BlockMetaState } from './types';
import { ActionTypes } from './actions';
import { ActionTypes as PostsActionTypes } from '../../Posts/actions';
import { Meta } from '../types';

export const INITIAL_STATE: BlockMetaState = {};

export const BlockMeta = (
  state = INITIAL_STATE,
  action: ReduxAction
): BlockMetaState => {
  const construstData = (loading: boolean, error: boolean): Meta => {
    return { loading, error };
  };
  switch (action.type) {
    case ActionTypes.BLOCK_LOAD_START:
    case PostsActionTypes.SHARE_POST_START: {
      const { blockId } = action;
      return {
        ...state,
        [blockId]: construstData(true, false),
      };
    }
    case ActionTypes.BLOCK_LOAD_FAILED:
    case PostsActionTypes.SHARE_POST_FAILED: {
      const { blockId } = action;
      return {
        ...state,
        [blockId]: construstData(false, true),
      };
    }
    case ActionTypes.BLOCK_LOAD_SUCCESS:
    case PostsActionTypes.SHARE_POST_SUCCESS: {
      const { blockId } = action;
      return {
        ...state,
        [blockId]: construstData(false, false),
      };
    }
    case ActionTypes.REMOVE_BLOCK_META: {
      const newState = state;
      const { blockId } = action;
      delete newState[blockId];
      return { ...newState };
    }
    default: {
      return state;
    }
  }
};
